import LoyaltyProgramPage from "./loyalty-program.container";

export default LoyaltyProgramPage;
